import * as Yup from 'yup';

import { requiredPhone, requiredString } from '@/validation/common';

const requiredStationsSchema = Yup.array()
  .of(
    Yup.object({
      id: requiredString,
      title: requiredString,
      details: requiredString,
    }),
  )
  .required('members.userForm.stationsRequired')
  .min(1, 'members.userForm.stationsRequired');

const memberRoles = {
  admin: Yup.boolean().default(false),
  adminAt: Yup.array().when('admin', {
    is: true,
    then: requiredStationsSchema,
  }),

  member: Yup.boolean()
    .when('admin', {
      is: false,
      then: Yup.boolean().isTrue('members.userForm.permissionsRequired'),
    })
    .default(true),

  memberAt: Yup.array().when('member', {
    is: true,
    then: requiredStationsSchema,
  }),
};

export const inviteMemberSchema = Yup.object({
  phone: requiredPhone,
  firstName: requiredString,
  ...memberRoles,
}).required();

export const editMemberSchema = Yup.object(memberRoles).required();
